import { useState } from "react";

const ACCESS_PIN = "0818";
const STORAGE_KEY = "pp_site_unlocked";

export default function ComingSoonGate({ children }) {
  const [unlocked, setUnlocked] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "1"; } catch { return false; }
  });
  const [pin, setPin] = useState("");
  const [error, setError] = useState(false);

  if (unlocked) return children;

  const submit = (e) => {
    e.preventDefault();
    if (pin.trim() === ACCESS_PIN) {
      try { localStorage.setItem(STORAGE_KEY, "1"); } catch {}
      setUnlocked(true);
    } else {
      setError(true);
      setPin("");
    }
  };

  return (
    <div className="min-h-screen bg-navy-dark relative overflow-hidden flex items-center justify-center px-6" data-testid="coming-soon-gate">
      {/* Ambient electric glow */}
      <div className="pointer-events-none absolute -top-40 -left-40 w-[500px] h-[500px] rounded-full bg-electric/20 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-48 -right-32 w-[520px] h-[520px] rounded-full bg-royal/25 blur-[130px]" />
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, #fff 1px, transparent 0)", backgroundSize: "28px 28px" }} />

      <div className="relative z-10 w-full max-w-md text-center">
        {/* Logo */}
        <div className="flex items-center justify-center gap-3 mb-10">
          <span className="relative inline-flex items-baseline metal-text font-serif leading-none select-none drop-shadow-[0_0_14px_rgba(0,140,255,0.3)]" aria-hidden="true">
            <span className="text-5xl">C</span>
            <span className="text-5xl -ml-3">C</span>
          </span>
          <span className="flex flex-col leading-none text-left">
            <span className="font-serif text-white text-3xl tracking-tight">Collins Crafty</span>
            <span className="text-chrome/60 text-[11px] font-semibold tracking-[0.32em] mt-1">CREATIONS</span>
          </span>
        </div>

        <div className="inline-block rounded-full border border-electric/40 bg-electric/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.25em] text-electric mb-6">
          Coming Soon
        </div>

        <h1 className="font-serif text-4xl sm:text-5xl text-white leading-tight">
          Something Handmade<br />Is On The Way
        </h1>
        <p className="text-chrome/60 mt-4 text-sm sm:text-base max-w-sm mx-auto">
          We're putting the finishing touches on our handmade printing & custom apparel shop. Enter your access PIN to preview the store.
        </p>

        <form onSubmit={submit} className="mt-9 flex flex-col items-center gap-3" data-testid="pin-form">
          <input
            type="password"
            inputMode="numeric"
            autoComplete="off"
            value={pin}
            onChange={(e) => { setPin(e.target.value); setError(false); }}
            placeholder="Enter access PIN"
            data-testid="pin-input"
            className="w-full rounded-md bg-white/5 border border-white/15 focus:border-electric focus:ring-2 focus:ring-electric/30 outline-none text-center text-white text-lg tracking-[0.4em] px-4 py-3.5 placeholder:text-white/30 placeholder:tracking-normal placeholder:text-base transition-colors"
          />
          {error && <p className="text-electric text-sm" data-testid="pin-error">Incorrect PIN. Please try again.</p>}
          <button
            type="submit"
            data-testid="pin-submit"
            className="w-full rounded-md bg-royal hover:bg-electric text-white px-6 py-3.5 text-xs font-bold uppercase tracking-[0.2em] transition-colors glow-blue"
          >
            Enter Site
          </button>
        </form>

        <p className="text-chrome/30 text-xs mt-10 font-script text-base">Handmade with heart.</p>
      </div>
    </div>
  );
}
